import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
    * **Web Book**
    *
    * @exports bs_473
    * @category engines
    */
const factory = function factory({ window, document, thn }) {
    let refreshPrice = null;
    const data = {};
    const roomDetailsParseData = (numAdults, numChildren) => {
        const roomsArray = Array.from(document.querySelectorAll('.room-list-view tbody'));
        if (thn.empty(roomsArray)) {
            return [];
        }
        const roomsInfo = roomsArray.map((room) => {
            const roomName = room.querySelector('tr td:nth-child(2)')?.textContent?.trim() || '';
            const roomType = getRoomType(roomName);
            const rateName = room.querySelector('tr td:nth-child(2)')?.textContent?.trim() || '';
            const ratePrice = thn.parseNumber(room.querySelector('tr td:nth-child(5)')?.textContent?.trim().split(' ')[1]) || 0;
            const hasBreakfast = true;
            const isRefundable = true;
            if (!roomName || !ratePrice) {
                return null;
            }
            const rateData = {
                name: rateName,
                totalNight: ratePrice,
                breakfast: hasBreakfast,
                refundable: isRefundable,
            };
            if (!roomName) {
                return null;
            }
            const roomData = {
                name: roomName,
                adults: numAdults || 2,
                children: numChildren || 0,
                type: roomType,
                prices: [rateData],
            };
            return roomData;
        });
        return roomsInfo.filter((value) => value !== null);
    };
    return {
        onStateChange: thn.debounce(() => {
            thn.pageCheck();
        }, 500),
        boot() {
            const container = document.querySelector('#main-container');
            if (container) {
                const refreshPage = thn.debounce(() => {
                    thn.pageCheck();
                }, 1000);
                thn.observeDom(container, refreshPage, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                });
                thn.shutdown(() => {
                    refreshPage.cancel();
                    thn.stopObserveDom(container, refreshPage);
                });
            }
            function extractDataFromUrl(url) {
                const urlObject = new URL(url, window.location.origin);
                const roomsObj = JSON.parse(urlObject.searchParams.get('rooms') || 'null');
                if (roomsObj) {
                    data.rooms = roomsObj;
                }
            }
            const observer = new PerformanceObserver((list) => {
                list.getEntries().forEach((entry) => {
                    if (entry.initiatorType === 'xmlhttprequest'
                        && entry.name.includes('roomtype/search')) {
                        extractDataFromUrl(entry.name);
                        if (thn.widgets.price.isTargetPage()) {
                            thn.widgets.price.refresh().catch(() => { });
                        }
                    }
                });
            });
            observer.observe({ type: 'resource', buffered: true });
            thn.shutdown(() => {
                observer.disconnect();
            });
        },
        generateSearchUrl(ctx) {
            const url = new URL(ctx.baseUrl);
            const validUrl = url.host.includes('us01.iqwebbook.com');
            // https://us01.iqwebbook.com/OWNOR529/~/?arrivalDate=Tue, Oct 1 2024&departureDate=Wed, Oct 2 2024&rooms=[{"adultsCount":1,"childrenCount":0}]
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            function formatDateStr(dateString) {
                const date = new Date(dateString);
                const formattedDate = date.toLocaleDateString('en-US', {
                    weekday: 'short',
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                });
                return formattedDate;
            }
            const dateBegin = formatDateStr(ctx.data.dateBegin);
            const dateEnd = formatDateStr(ctx.data.dateEnd);
            // In case of multirooms we are not able to get the data of the other rooms, so we will just use the first one
            const rooms = [{ adultsCount: ctx.data.adults, childrenCount: ctx.data.children }];
            if (dateBegin && dateEnd && rooms) {
                url.searchParams.set('arrivalDate', dateBegin);
                url.searchParams.set('departureDate', dateEnd);
                url.searchParams.set('rooms', JSON.stringify(rooms));
                ctx.newUrl = url.toString();
            }
            return ctx;
        },
        priceObserveDom(ctx) {
            const container = document.querySelector('.icon-clock')?.parentElement;
            if (container && !refreshPrice) {
                refreshPrice = thn.debounce(() => {
                    const isLoading = thn.isVisible(document.querySelector('.fa-spinner'));
                    if (!isLoading) {
                        ctx.widget.refresh().catch(() => { });
                    }
                }, 500);
                thn.observeDom(container, refreshPrice, {
                    attributes: true,
                });
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        refreshPrice.cancel();
                        thn.stopObserveDom(container, refreshPrice);
                        refreshPrice = null;
                    }
                });
            }
        },
        priceParseData() {
            // Dates
            function padDay(dateString) {
                const dateParts = dateString.trim().split(' ');
                const day = dateParts[2];
                const parsedDay = thn.parseNumber(day);
                const paddedDay = parsedDay !== undefined && parsedDay < 10 ? `0${parsedDay}` : day;
                return `${dateParts[0]} ${dateParts[1]} ${paddedDay}`;
            }
            const year = document.querySelector('.uib-daypicker td[id*=datepicker] .btn-primary')?.closest('td')?.closest('tbody')?.closest('table')
                ?.querySelector('thead h3')?.textContent?.trim().split(' ')[1] || '';
            const datesElement = document.querySelector('.icon-calendar')?.parentElement;
            const stringDateArray = datesElement?.textContent?.trim().split('-') || [];
            const dayEnd = stringDateArray[1]?.replace(/\s*\(.*?\)\s*/, '').trim() || '';
            const dateBegin = translateDate(`${padDay(stringDateArray[0])} ${year}`, thn.data.language);
            const dateEnd = translateDate(`${padDay(dayEnd)} ${year}`, thn.data.language);
            if (!dateBegin || !dateEnd) {
                return null;
            }
            // Price and currency
            const pricesArray = Array.from(document.querySelectorAll('.room-list-view tbody'));
            const prices = pricesArray.map((p) => thn.parseNumber(p.querySelector('tr td:nth-child(5)')?.textContent?.trim().split(' ')[1])).filter((value) => typeof value !== 'undefined' && value !== null);
            const currency = 'GBP';
            const noAvailability = prices.every((item) => item === null);
            const price = !thn.empty(prices) && Math.min(...prices);
            // Guests
            const guestsElement = document.querySelector('.icon-users')?.parentElement;
            const guestsArray = guestsElement?.textContent?.trim().split(',') || [];
            const guests = data.rooms || [];
            let adults = guests?.[0]?.adultsCount || thn.parseNumber(guestsArray[1]) || 2;
            let children = guests?.[0]?.childrenCount || thn.parseNumber(guestsArray[2]) || 0;
            let rooms = 1;
            // In case of multiroom we get the less occupied room
            if (guests.length > 1) {
                guests.forEach((room) => {
                    if (room.adultsCount <= adults && room.childrenCount <= children) {
                        adults = room.adultsCount;
                        children = room.childrenCount;
                    }
                });
            }
            if (thn.empty(prices)) {
                rooms = guests?.length || thn.parseNumber(guestsArray[0]) || 1;
            }
            if (price && currency) {
                return {
                    dateBegin,
                    dateEnd,
                    adults,
                    children,
                    rooms,
                    roomDetails: roomDetailsParseData(adults, children),
                    price,
                    currency,
                };
            }
            if (!price || noAvailability) {
                return {
                    dateBegin,
                    dateEnd,
                    adults,
                    children,
                    rooms,
                    noRooms: true,
                };
            }
            return null;
        },
        bookingParseData() {
            const bookingId = document.querySelectorAll('.form-control-static')[0]?.textContent?.trim();
            if (!bookingId) {
                return {
                    set: false,
                };
            }
            const dateBeginNoFormat = document.querySelectorAll('.form-control-static')[1]?.textContent?.trim();
            const dateEndNoFormat = document.querySelectorAll('.form-control-static')[2]?.textContent?.trim();
            const dateBegin = dateBeginNoFormat ? translateDate(dateBeginNoFormat, thn.data.language) : '';
            const dateEnd = dateEndNoFormat ? translateDate(dateEndNoFormat, thn.data.language) : '';
            const guestsElement = document.querySelectorAll('.form-control-static')[4]?.textContent?.trim();
            const adults = thn.parseNumber(guestsElement?.split(',')[0].split(' ')[0]) || 1;
            const children = thn.parseNumber(guestsElement?.trim().split(',')[1].split(' ')[0]) || 0;
            const price = thn.parseNumber(document.querySelectorAll('.totals .form-control-static')[3]?.textContent?.trim().split(' ')[1]);
            const currency = thn.parseCurrency(document.querySelectorAll('.totals .form-control-static')[3]?.textContent?.trim().split(' ')[0]);
            return {
                bookingId,
                dateBegin,
                dateEnd,
                adults,
                children,
                price,
                currency,
            };
        },
    };
};

export { factory };
